import React from "react";
import { compose, branch } from "recompose";
import AvailableStoreQuery from "./AvailableStoreQuery.gql";
import EnhanceStoreViewSelector from "./EnhanceStoreViewSelector";
import StoreViewUrlQuery from "./StoreViewUrlQuery.gql";
import getShopName from "./getShopName";
import { defineMessages, useIntl } from "react-intl";
import Selector from "theme/components/molecules/Selector";
const messages = defineMessages({
  title: {
    id: "modules.User.StoreViewSelector.title",
    defaultMessage: "Change language",
  },
});

const StoreViewSelector = (props) => {
  const intl = useIntl();
  return (
    <span className="store-view-selector-wrapper">
      <Selector
        options={props.data.availableStores.map((id) => ({
          value: id,
          label: getShopName(id, intl),
        }))}
        title={intl.formatMessage(messages.title)}
        current={getShopName(props.data.shop.id, intl)}
        value={props.data.shop.id}
        onSelect={props.setStoreView}
        spanWrapper={true}
      />
    </span>
  );
};

export default compose(
  EnhanceStoreViewSelector({ AvailableStoreQuery, StoreViewUrlQuery }),
  branch(
    (props) => props.data.loading,
    () => () => null,
    (BaseComponent) => BaseComponent
  )
)(StoreViewSelector);
